import React from'react';
import styled from '@emotion/styled';

interface HeaderMobileProps {
  disable: boolean;
}
const HeaderPC:React.FC<HeaderMobileProps> = ({ disable }) => {
  const handleGotoHomapage:React.MouseEventHandler<HTMLDivElement> | undefined = () => {
    window.location.href="https://photypeta.com"
  };

  const handleGotologin = () => {
    window.location.href="https://app.photypeta.com/login"
  }
  
  return(
    <Container>
      <ImgContainer
        onClick={!disable ? undefined : handleGotoHomapage}
      >
        <LogoImg src='/images/logoImg2.png'/>
      </ImgContainer>
    </Container>
  )
};

export default HeaderPC;

const Container = styled.div`
  max-width: 1024px;
  width: 95%;
  height: 69px;
  
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  margin: 0 auto;
`;
const ImgContainer = styled.div`
  width: 118px;
  height: 25.62px;
  margin-left: 17px;
`
const LogoImg = styled.img`
  width: 100%;
`;